// import * as Popper from "@popperjs/core"
// import * as bootstrap from 'bootstrap';

import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

async function configureFontAwesome() {
    const {
        config,
        library,
        dom } = await import(/* webpackPreload: true */ '@fortawesome/fontawesome-svg-core');
    const { 
        faCalendar,
        faHome,
        faPowerOff,
        faUpRightFromSquare,
        faWarning,
        faInfoCircle,
        faLink,
        faCircleExclamation } = await import(/* webpackPreload: true */ '@fortawesome/pro-solid-svg-icons');
    
    config.keepOriginalSource = false;
    config.styleDefault = 'solid';
    library.add(faHome, faWarning, faInfoCircle, faPowerOff, faUpRightFromSquare, faCircleExclamation, faCalendar, faLink);
    
    dom.i2svg()
    dom.watch()
}

if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', configureFontAwesome);
}
else {
    configureFontAwesome();
}